export default __webpack_public_path__ + "static/media/logo.e541a37a.png";